export const SITE_NAME = '株式会社ルヴィラ';
export const SITE_NAME_EN = 'Luvira Inc.';
export const SITE_EMAIL = 'contact@luvira.co.jp';
export const SITE_PHONE = '050-5367-5817';
export const SITE_LOGO =
  'https://media.genaiweb.ai/1cfcb9a7-5410-444f-8143-602b7e61a697/logo.png';

export const SITE_DEFAULT_DESCRIPTION =
  '株式会社ルヴィラは、AIを活用して会社の成長を妨げる業務・情報・判断の滞りを見つけ、改善します。AI業務改善、AIシステム開発、AI運用・改善支援、AI集客支援を全国オンラインで提供します。';

const rawSiteUrl = (import.meta.env.VITE_SITE_URL || '').trim();

/**
 * Real site origin. Uses the platform-provided VITE_SITE_URL. When it is not
 * available at runtime (e.g. local dev), falls back to the current origin.
 */
export const SITE_ORIGIN = (
  rawSiteUrl || (typeof window !== 'undefined' ? window.location.origin : '')
).replace(/\/+$/, '');

export function absoluteUrl(path: string): string {
  if (!path) return SITE_ORIGIN;
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized}`;
}